import { useRights } from '../hooks/useRights';

/**
 * Action rights for different entity types
 */
export const studentActions = (): string[] => ['students:u', 'students:d'];
export const teacherActions = (): string[] => ['teachers:u', 'teachers:d'];
export const classeActions = (): string[] => ['classes:u', 'classes:d', 'scores:c', 'bulletins:c'];
export const courseActions = (): string[] => ['courses:u', 'courses:d'];
export const levelActions = (): string[] => ['levels:u', 'levels:d'];
export const profileActions = (): string[] => ['profiles:u'];

/**
 * Hook to check if user has any action right for a given entity type
 * @param actionRights Array of action rights to check
 * @returns true if user has at least one of the action rights
 */
export const useHasAnyActionRight = (actionRights: string[]): boolean => {
  const { hasAnyRight, isSuperAdmin } = useRights();
  
  // SuperAdmin has all rights
  if (isSuperAdmin) {
    return true;
  }
  
  return hasAnyRight(actionRights);
};


